module.exports = __webpack_public_path__ + "assets/b72802f8ef8122ecfb73425f409201df.mp3";